{
  "SEARCH": {
    "TABS": {
      "ALL": "All results",
      "CONTACTS": "Yhteystiedot",
      "CONVERSATIONS": "Keskustelut",
      "MESSAGES": "Messages",
      "ARTICLES": "Articles"
    },
    "SECTION": {
      "CONTACTS": "Yhteystiedot",
      "CONVERSATIONS": "Keskustelut",
      "MESSAGES": "Messages",
      "ARTICLES": "Articles"
    },
    "VIEW_MORE": "View more",
    "LOAD_MORE": "Load more",
    "SEARCHING_DATA": "Searching",
    "LOADING_DATA": "Loading",
    "EMPTY_STATE": "No {item} found for query '{query}'",
    "EMPTY_STATE_FULL": "No results found for query '{query}'",
    "PLACEHOLDER_KEYBINDING": "/to focus",
    "INPUT_PLACEHOLDER": "Search messages, contacts or conversations",
    "RECENT_SEARCHES": "Recent searches",
    "CLEAR_ALL": "Clear all",
    "MOST_RECENT": "Most recent",
    "EMPTY_STATE_DEFAULT": "Search by conversation id, email, phone number, messages for better search results.",
    "BOT_LABEL": "Botti",
    "READ_MORE": "Read more",
    "READ_LESS": "Read less",
    "WROTE": "wrote:",
    "FROM": "From",
    "EMAIL": "Sähköposti",
    "EMAIL_SUBJECT": "Subject",
    "PRIVATE": "Private note",
    "TRANSCRIPT": "Transcript",
    "CREATED_AT": "created {time}",
    "UPDATED_AT": "updated {time}",
    "SORT_BY": {
      "RELEVANCE": "Relevance"
    },
    "DATE_RANGE": {
      "LAST_7_DAYS": "Viimeiset 7 päivää",
      "LAST_30_DAYS": "Viimeiset 30 päivää",
      "LAST_60_DAYS": "Viimeiset 60 päivää",
      "LAST_90_DAYS": "Viimeiset 90 päivää",
      "CUSTOM_RANGE": "Custom range:",
      "CREATED_BETWEEN": "Created between",
      "AND": "and",
      "APPLY": "Apply",
      "BEFORE_DATE": "Before {date}",
      "AFTER_DATE": "After {date}",
      "TIME_RANGE": "Filter by time",
      "CLEAR_FILTER": "Clear filter"
    },
    "FILTERS": {
      "FILTER_MESSAGE": "Filter messages by:",
      "FROM": "Sender",
      "IN": "Inbox",
      "AGENTS": "Edustajat",
      "CONTACTS": "Yhteystiedot",
      "INBOXES": "Saapuneet-kansiot",
      "NO_AGENTS": "Edustajia ei löytynyt",
      "NO_CONTACTS": "Start by searching to see results",
      "NO_INBOXES": "No inboxes found"
    }
  }
}
